import { usePublishedData } from "../lib/published-data";
import { createFileRoute, redirect, useLocation } from "@tanstack/react-router";
import { DocumentContent } from "../components/document-content";
import { documentHead, loadPage, useShell } from "../lib/document-route";

/**
 * The creator's own pages (/resources, /events/summer) and policy pages, which share the
 * document runtime ([...creatorPage].astro). A page is served at its canonical address.
 */
export const Route = createFileRoute("/$")({
  loader: async ({ location }) => {
    const path = location.pathname.replace(/\/+$/, "") || "/";
    const data = await loadPage(path, "missing");
    if (data.kind === "page" && location.pathname !== data.page.path)
      throw redirect({ href: data.page.path + location.searchStr, statusCode: 301 });
    return data;
  },
  head: ({ matches, loaderData, match }) =>
    documentHead(matches, loaderData, match.pathname, {
      title: (shell) => `Page not found | ${shell.creator.name}`,
      description: () => "This page could not be found.",
    }),
  component: CreatorPage,
});

function CreatorPage() {
  const shell = useShell();
  const path = useLocation().pathname;
  const { data } = usePublishedData(Route.useLoaderData(), shell, path, "page");
  return data.kind === "page" ? <DocumentContent data={data} shell={shell} /> : null;
}
